import React, { useState } from 'react'
import { Modal, Button, Form } from 'semantic-ui-react';
import PropTypes from "prop-types";
import { useMessageResources, useTextResources } from '../../language';
import { useConfirm } from "../../hooks/useConfirm";

const SaleGuideCommentsPopup = ({ rateData, startOpen, onSave, onClose, ...params }) => {
    const text = useTextResources();
    const confirm  = useConfirm();
    const message = useMessageResources();

    const [open, setOpen] = useState(startOpen);
    const [rateSaleGuide, setRateSaleGuide] = useState(rateData?.rateSaleGuide);
    const [reservationComments, setReservationComments] = useState(rateData?.reservationComments);

    const save = async () => {
        if (onSave) {
            await onSave({
                ...rateData,
                reservationComments: reservationComments,
                rateSaleGuide: rateSaleGuide,
            });
        }
        close(false);
    }

    const close = async (isHandleCloseButton) => {

        let isDirty = isHandleCloseButton === true &&
            (rateData.reservationComments !== reservationComments ||
                rateData.rateSaleGuide !== rateSaleGuide);

        if (isDirty && !(await confirm(
            {
                content: `${message("WouldYouLikeToContinue")}?`,
                confirmButton: {
                    content: text('Yes'),
                    positive: true,
                },
                cancelButton: {
                    content: text('No'),
                    negative: true,
                },
            }))) {
            return;
        }

        if (isHandleCloseButton) {
            //reset to original when approve close
            setReservationComments(rateData.reservationComments);
            setRateSaleGuide(rateData.rateSaleGuide);
        }

        setOpen(false);
        if (onClose) {
            onClose();
        }
    }

    return (
        <Modal size="small" open={open} style={{ zIndex: 1000000 }} {...params} >
            <Modal.Header>{text("RateSaleGuideAndReservationComments")}</Modal.Header>
            <Modal.Content>
                <Form>
                    <Form.TextArea
                        label={text("RateSaleGuideLabel")}
                        rows={5}
                        maxLength='2000'
                        onChange={(e, data) =>
                            setRateSaleGuide(data.value)
                        }
                        value={rateSaleGuide}
                    />
                    <Form.TextArea
                        label={text("ReservationCommentsLabel")}
                        rows={5}
                        maxLength='2000'
                        onChange={(e, data) =>
                            setReservationComments(data.value)
                        }
                        value={reservationComments}
                    />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button size={"small"} negative onClick={() => close(true)}>{text("Close")}</Button>
                <Button size={"small"} positive onClick={save}>{text("Save")}</Button>
            </Modal.Actions>
        </Modal>
    )
}

SaleGuideCommentsPopup.propTypes = {
    rateData: PropTypes.object,
    onSave: PropTypes.func,
    onClose: PropTypes.func,
    startOpen: PropTypes.bool,
}

export default SaleGuideCommentsPopup